import { useState } from "react";
import { faqs } from "@/mocks/home";
import Reveal from "./Reveal";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="text-xs tracking-[0.3em] text-secondary-500 uppercase">FAQ</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              回看前常见问题
            </h2>
            <p className="mt-3 text-sm md:text-base leading-7 text-foreground-700">
              关于历史记录的排序方式、往期合集的用法，以及信息标注的口径，先在这里说清楚，回看时更省心。
            </p>
          </div>

          <div className="lg:col-span-8 flex flex-col gap-3">
            {faqs.map((item, index) => {
              const isOpen = open === index;
              return (
                <Reveal
                  key={item.q}
                  delay={index * 50}
                  className="bg-background-50 border border-background-200 rounded-lg overflow-hidden"
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : index)}
                    className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
                  >
                    <span className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                      {item.q}
                    </span>
                    <span
                      className={`w-8 h-8 shrink-0 rounded-md flex items-center justify-center transition-colors ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 md:px-6 pb-5 -mt-1">
                      <p className="text-sm leading-7 text-foreground-700 border-t border-background-200 pt-4">
                        {item.a}
                      </p>
                    </div>
                  )}
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}